
import axios from 'axios';
import localforage from 'localforage';

const CONFIG_KEY = 'APP_CONFIG';
const TIMESTAMP_KEY = 'APP_CONFIG_TIMESTAMP';

const configStore = localforage.createInstance({
    name: 'AppConfigStore'
});
export const loadConfig = async () => {
    const configFile = await fetch('/config.json');
    const fileConfig = await configFile.json();
    const baseURL = fileConfig.API_BASE_URL;

    const savedTimestamp = await configStore.getItem(TIMESTAMP_KEY);
    let savedConfig = await configStore.getItem(CONFIG_KEY);


    try {

        const response = await axios.get(`${baseURL}/config/app?serviceApp=true` );

        const {timestamp } = response.data.data;

        if (!savedTimestamp || savedTimestamp !== timestamp) {
            await configStore.setItem(CONFIG_KEY, response.data.data);
            await configStore.setItem(TIMESTAMP_KEY, timestamp);
            savedConfig = response.data.data;
        }

        savedConfig._serverError = false;
        window.APP_CONFIG = savedConfig;
    } catch (err) {
        console.error('Error fetching config from API:', err);
        throw new Error('No config data and API failed');


        // اگر کش داریم، از همون استفاده می‌کنیم ولی به اپ اطلاع می‌دیم که سرور قطع بوده
     /*   savedConfig._serverError = true;
        window.APP_CONFIG = savedConfig;*/
    }
};

